import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class ReviewTimecardService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  async getReviewGrid(
    employeeID,
    timecardID,
    action,
    timecardRows,
    timecardColumns,
    timecardPersistID,
    isSubmitted,
    portalSettings,
    crewTemplateID,
    reviewAll,
    currencySymbol
  ) {
    var rawRows;
    var rows;
    var earnCodes;
    var columns;
    var hours;
    var expenses;
    var totals;
    var useOverhead = portalSettings.EnableOverheadLineType.ConfigValue == '1';
    var amountBasedEarnCodesSetting = portalSettings.AmountBasedEarnCodes.ConfigValue;
    var amountEarnCodes = [];
    var http = this.http;
    if (amountBasedEarnCodesSetting != null) {
      amountEarnCodes = amountBasedEarnCodesSetting.split(',');
    }
    var rowsLoaded = false;
    var columnsLoaded = false;
    var alert = null;
    var expenseExists = false;
    rawRows = _.cloneDeep(timecardRows);
    hours = {};
    earnCodes = [];
    rows = {};
    var hasAttachments = { J: false, M: false, S: false, O: false };
    columns = {};
    rawRows != null ? await parseRows() : await requestRowData();
    if (rowsLoaded && columnsLoaded) {
      return {
        hours: hours,
        expenses: expenses,
        totals: totals,
        rows: rows,
        columns: columns,
        earnCodes: earnCodes,
        action: action,
        alert: alert,
        hasAttachments: hasAttachments,
      };
    }
    async function parseRows() {
      //#284878 Standard Timecard and Timecard Approval - Manager view approval screen sorting.
      if (action == 'approve') {
        rawRows = rawRows.reverse();
      }
      var hourTotals = { J: { Total: 0 }, M: { Total: 0 }, S: { Total: 0 }, O: { Total: 0 } };
      var expenseTotals = { J: { Expenses: 0 }, M: { Expenses: 0 }, S: { Expenses: 0 }, O: { Expenses: 0 } };
      var rowsByType = { J: [], M: [], S: [], O: [] };
      rawRows.forEach((rawRow: any) => {
        rawRow.IsAmountRow = isAmountRow(rawRow);
        rawRow.Hours = rawRow.Hours ?? 0;
        var earnCode = rawRow.EarnCode;
        var earnCodeValue = parseInt(earnCode.substring(0, earnCode.trim().indexOf(' ')));
        var earnCodeFound = earnCodes.find(earnCode => earnCode.Value === earnCodeValue);

        if (!earnCodeFound) {
          var isAmount = isAmountEarnCode(earnCodeValue);
          earnCodes.push({ Value: earnCodeValue, DisplayName: earnCode, Type: isAmount ? 'E' : 'H' });
        }
        rowsByType[rawRow.Type].push(rawRow);
        if (rawRow.Type == 'J') {
          if (rawRow.Job == null) {
            if (rawRow.IsAmountRow) {
              expenseExists = true;
              expenseTotals.O.Expenses += parseFloat(rawRow.Hours);
              if (expenseTotals.O[earnCodeValue] == null) {
                expenseTotals.O[earnCodeValue] = parseFloat(rawRow.Hours);
              } else {
                expenseTotals.O[earnCodeValue] += parseFloat(rawRow.Hours);
              }
            } else {
              hourTotals.O.Total += parseFloat(rawRow.Hours);
              if (hourTotals.O[earnCodeValue] == null) {
                hourTotals.O[earnCodeValue] = parseFloat(rawRow.Hours);
              } else {
                hourTotals.O[earnCodeValue] += parseFloat(rawRow.Hours);
              }
            }
          } else {
            if (rawRow.IsAmountRow) {
              expenseExists = true;
              expenseTotals.J.Expenses += parseFloat(rawRow.Hours);
              if (expenseTotals.J[earnCodeValue] == null) {
                expenseTotals.J[earnCodeValue] = parseFloat(rawRow.Hours);
              } else {
                expenseTotals.J[earnCodeValue] += parseFloat(rawRow.Hours);
              }
              rawRow.Hours = currencySymbol + rawRow.Hours;
            } else {
              hourTotals.J.Total += parseFloat(rawRow.Hours);
              if (hourTotals.J[earnCodeValue] == null) {
                hourTotals.J[earnCodeValue] = parseFloat(rawRow.Hours);
              } else {
                hourTotals.J[earnCodeValue] += parseFloat(rawRow.Hours);
              }
            }
          }
        } else if (rawRow.Type == 'O') {
          if (rawRow.IsAmountRow) {
            expenseExists = true;
            expenseTotals.O.Expenses += parseFloat(rawRow.Hours);
            if (expenseTotals.O[earnCodeValue] == null) {
              expenseTotals.O[earnCodeValue] = parseFloat(rawRow.Hours);
            } else {
              expenseTotals.O[earnCodeValue] += parseFloat(rawRow.Hours);
            }
          } else {
            hourTotals.O.Total += parseFloat(rawRow.Hours);
            if (hourTotals.O[earnCodeValue] == null) {
              hourTotals.O[earnCodeValue] = parseFloat(rawRow.Hours);
            } else {
              hourTotals.O[earnCodeValue] += parseFloat(rawRow.Hours);
            }
          }
        } else {
          if (rawRow.IsAmountRow) {
            expenseTotals[rawRow.Type].Expenses += parseFloat(rawRow.Hours);
            if (expenseTotals[rawRow.Type][earnCodeValue] == null) {
              expenseTotals[rawRow.Type][earnCodeValue] = parseFloat(rawRow.Hours);
            } else {
              expenseTotals[rawRow.Type][earnCodeValue] += parseFloat(rawRow.Hours);
            }
          } else {
            hourTotals[rawRow.Type].Total += parseFloat(rawRow.Hours);
            if (hourTotals[rawRow.Type][earnCodeValue] == null) {
              hourTotals[rawRow.Type][earnCodeValue] = parseFloat(rawRow.Hours);
            } else {
              hourTotals[rawRow.Type][earnCodeValue] += parseFloat(rawRow.Hours);
            }
          }
        }
      });
      hours = hourTotals;
      expenses = expenseTotals;
      earnCodes = earnCodes.sort((a, b) => (a.Value < b.Value ? -1 : 1));
      earnCodes.push({ Value: 'Total', DisplayName: 'Total Hours', Type: 'H' });
      if (expenseExists) {
        earnCodes.push({ Value: 'Expenses', DisplayName: 'Total Expenses', Type: 'E' });
      }

      Object.keys(hourTotals).forEach(type => {
        Object.keys(hourTotals[type]).forEach(code => {
          hours[type][code] = hourTotals[type][code].toFixed(2);
        });
      });

      Object.keys(expenseTotals).forEach(type => {
        Object.keys(expenseTotals[type]).forEach(code => {
          expenses[type][code] = expenseTotals[type][code].toFixed(2);
        });
      });

      rows = rowsByType;
      //check if rows have attachments
      if (portalSettings.TCAttachmentMode.ConfigValue != null && portalSettings.TCAttachmentMode.ConfigValue != 'N') {
        Object.entries(rows).forEach(([rowtype, rowcollection]) => {
          Object.entries(rowcollection).forEach(([rowkey, row]) => {
            if (row.HasAttachments !== null && row.HasAttachments === '1') {
              hasAttachments[row.Type] = true;
            }
          });
        });
      }
      rowsLoaded = true;
      await getColumns();
    }

    async function requestRowData() {
      var requestURL = '/timecard/rows/?employeeId=' + employeeID + '&timecardId=' + timecardID + '&filterType=A';
      if (crewTemplateID != null && !reviewAll) {
        requestURL += '&crewTemplateID=' + crewTemplateID;
      } else {
        if (reviewAll) {
          requestURL += '&crewTemplateID=-1';
        }
      }
      await http
        .get(requestURL)
        .toPromise()
        .then(async (response: any) => {
          var rawRowsRequest = response;
          if (rawRowsRequest != '') {
            if (rawRowsRequest.Timecard != null) {
              rawRows = rawRowsRequest.Timecard;
            } else if (rawRowsRequest.Item != null) {
              rawRows = [rawRowsRequest.Item];
            }
          } else {
            if (rowsLoaded && columnsLoaded) {
              return {
                hours: hours,
                expenses: expenses,
                totals: totals,
                rows: rows,
                columns: columns,
                earnCodes: earnCodes,
                action: action,
                alert: alert,
                hasAttachments: hasAttachments,
              };
            }
          }

          if (rawRows != null && rawRows.length > 0) {
            await parseRows();
          } else {
            alert = { type: 'danger', msg: 'There are no rows on this timecard.' };
          }
        });
    }

    async function getColumns() {
      if (timecardColumns != null) {
        Object.entries(timecardColumns).forEach(([key, val]) => {
          var cols = _.cloneDeep(val);
          processColumns(cols, key);
        });
      } else {
        await requestColumns('J');
        await requestColumns('M');
        await requestColumns('S');
        if (useOverhead) {
          await requestColumns('O');
        }
      }
    }

    async function requestColumns(lineType: any) {
      var isCrewOrStandard = crewTemplateID != null && crewTemplateID != '' ? 'C' : 'S';
      await http
        .get(
          '/Timecard/GetTimecardColumns?employeeId=' +
            employeeID +
            '&employee=' +
            null +
            '&pRCo=' +
            null +
            '&filterType=' +
            lineType +
            '&isCrewOrStandard=' +
            isCrewOrStandard
        )
        .toPromise()
        .then((response: any) => {
          var columnsToProcess = response;
          processColumns(columnsToProcess, lineType);
        });
    }

    function processColumns(columnsToProcess: any, lineType: any) {
      columns[lineType] = [];
      columnsToProcess.forEach((column: any) => {
        if (column.ColumnVisibilityModeID != 1) {
          columns[lineType].push(column);
          if (column.Datatype == 'bDate') {
            rows[lineType].forEach((row: any) => {
              if (row[column.ColumnName] != null) {
                var timeStr = row[column.ColumnName];
                var a = timeStr.split(' ');
                var d = a[0].split('-');
                var t = a[1].split(':');
                if (portalSettings.CountryDateCode.ConfigValue == 'US') {
                  row[column.ColumnName] = d[1] + '/' + d[2] + '/' + d[0];
                } else {
                  row[column.ColumnName] = d[2] + '/' + d[1] + '/' + d[0];
                }
              }
            });
          } else if (column.Datatype == 'bTime') {
            rows[lineType].forEach((row: any) => {
              if (row[column.ColumnName] != null) {
                var timeStr = row[column.ColumnName];
                var a = timeStr.split(' ');
                var d = a[0].split('-');
                var t = a[1].split(':');
                row[column.ColumnName] = new Date(d[0], d[1] - 1, d[2], t[0], t[1], t[2]).toString('hh:mm tt');
              }
            });
          }
        }
      });

      if (columns['J'] && columns['M'] && columns['S'] && (!useOverhead || columns['O'])) {
        totals = {};
        var totalHours = 0;
        earnCodes.forEach(earnCode => {
          let total = 0;
          Object.entries(hours).forEach(([type, hours]) => {
            if (hours[earnCode.Value] !== null && earnCode.Type === 'H') {
              total += parseFloat(hours[earnCode.Value] ?? 0);
            }
          });
          Object.entries(expenses).forEach(([type, expense]) => {
            if (expense[earnCode.Value] !== null && earnCode.Type === 'E') {
              total += parseFloat(expense[earnCode.Value] ?? 0);
            }
          });
          totals[earnCode.Value] = total.toFixed(2);
        });
        columnsLoaded = true;
      }
    }

    function isAmountRow(row: any) {
      if (row.EarnCode != null) {
        var earnCode = row.EarnCode;
        if (earnCode != null) {
          var spaceIndex = earnCode.indexOf(' ');
          if (spaceIndex != -1) {
            earnCode = earnCode.substr(0, earnCode.indexOf(' '));
          }
          earnCode = parseInt(earnCode);
        }
        return isAmountEarnCode(earnCode);
      } else {
        return false;
      }
    }
    function isAmountEarnCode(earnCode: any) {
      return amountEarnCodes.indexOf(earnCode.toString()) > -1;
    }
  }
}
